import { render, staticRenderFns } from "./CircleBadge.vue?vue&type=template&id=72f971fd&scoped=true"
import script from "./CircleBadge.vue?vue&type=script&lang=ts"
export * from "./CircleBadge.vue?vue&type=script&lang=ts"
import style0 from "./CircleBadge.vue?vue&type=style&index=0&id=72f971fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f971fd",
  null
  
)

export default component.exports